export default __webpack_public_path__ + "e36f2c633c1d0d7c73204c1e13860183.webp";